var _JsonConfigurationSection_source;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import ArgumentException from '../../Exceptions/ArgumentException';
import isNullOrEmpty from '../../TypeHelpers/isNullOrEmpty';
import isObject from '../../TypeHelpers/isObject';
import { parseKey } from '../_types';
export default class JsonConfigurationSection {
    constructor(source) {
        _JsonConfigurationSection_source.set(this, void 0);
        __classPrivateFieldSet(this, _JsonConfigurationSection_source, source, "f");
    }
    getSection(key) {
        if (isNullOrEmpty(key)) {
            return this;
        }
        const keys = parseKey(key);
        let i = 0;
        let result = __classPrivateFieldGet(this, _JsonConfigurationSection_source, "f");
        while (i < keys.length) {
            const partial = result[keys[i]];
            if (!isObject(partial)) {
                throw new ArgumentException("key", "Key is not a section. Try using get");
            }
            result = partial;
            i++;
        }
        return new JsonConfigurationSection(result);
    }
    get(key) {
        if (isNullOrEmpty(key)) {
            return __classPrivateFieldGet(this, _JsonConfigurationSection_source, "f");
        }
        else {
            const keys = parseKey(key);
            let i = 0;
            let result = __classPrivateFieldGet(this, _JsonConfigurationSection_source, "f");
            while (i < keys.length) {
                const value = result[keys[i]];
                if (isObject(value)) {
                    result = value;
                }
                else {
                    return value;
                }
                i++;
            }
            return result;
        }
    }
}
_JsonConfigurationSection_source = new WeakMap();
